import React, { useState, useEffect, useCallback } from 'react';
import { subscriptionService } from '../../services/subscriptionService';
import { API_ENDPOINTS } from '../../constants';
import { locationUtils } from '../../utils/locationUtils';

const PricingDebug = () => {
    const [apiStatus, setApiStatus] = useState('Testing...');
    const [apiData, setApiData] = useState(null);
    const [apiError, setApiError] = useState(null);
    const [endpoint] = useState(API_ENDPOINTS.SUBSCRIPTIONS.PLANS);
    const [locationData, setLocationData] = useState(null);

    const testApi = useCallback(async () => {
        setApiStatus('Testing...');
        setApiData(null);
        setApiError(null);

        try {
            console.log('Testing API endpoint:', endpoint);
            console.log('API Base URL:', process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001');
            
            // Get location data first
            const countryData = await locationUtils.detectUserCountry();
            setLocationData(countryData);
            console.log('Location Data:', countryData);
            
            const result = await subscriptionService.getPlans();
            console.log('API Result:', result);
            
            if (result.success) {
                setApiStatus('Success');
                setApiData(result.data);
            } else {
                setApiStatus('Failed');
                setApiError(result.error);
            }
        } catch (error) {
            console.error('API Test Error:', error);
            setApiStatus('Error');
            setApiError(error.message);
        }
    }, [endpoint]);

    useEffect(() => {
        testApi();
    }, [testApi]);

    return (
        <div style={{ padding: '20px', fontFamily: 'monospace', maxWidth: '800px' }}>
            <h2>Pricing API Debug</h2>
            
            <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#f5f5f5' }}>
                <h3>Configuration:</h3>
                <p><strong>API Base URL:</strong> {process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}</p>
                <p><strong>Endpoint:</strong> {endpoint}</p>
                <p><strong>Full URL:</strong> {(process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001') + endpoint}</p>
                {locationData && (
                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#e6f3ff', borderRadius: '5px' }}>
                        <h4>Location Detection:</h4>
                        <p><strong>Country:</strong> {locationData.countryName} ({locationData.countryCode})</p>
                        <p><strong>Currency:</strong> {locationData.currency}</p>
                        <p><strong>Detection Method:</strong> {locationData.fallback ? 'Browser Fallback' : 'IP Geolocation'}</p>
                        <p><strong>Query Parameter:</strong> ?country_code={locationData.countryCode}</p>
                    </div>
                )}
            </div>

            <div style={{ marginBottom: '20px' }}>
                <h3>API Status: {apiStatus}</h3>
                <button onClick={testApi} style={{ padding: '10px', marginRight: '10px' }}>
                    Test API Again
                </button>
            </div>

            {apiError && (
                <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#ffe6e6', border: '1px solid #ff9999' }}>
                    <h3>Error:</h3>
                    <pre>{apiError}</pre>
                </div>
            )}

            {apiData && (
                <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#e6ffe6', border: '1px solid #99ff99' }}>
                    <h3>API Data:</h3>
                    <pre>{JSON.stringify(apiData, null, 2)}</pre>
                </div>
            )}

            <div style={{ marginBottom: '20px' }}>
                <h3>Expected Data Format:</h3>
                <pre>{JSON.stringify([
                    {
                        id: 1,
                        plan_name: "Free",
                        base_price: 0,
                        user_limit: 1,
                        ai_tokens_limit: 1000,
                        features: ["API Access", "Email Support", "Basic Dashboard"]
                    }
                ], null, 2)}</pre>
            </div>
        </div>
    );
};

export default PricingDebug; 